const topBrands = {
  success: true,
  brandsList: [
    {
      _id: "64177a6bc1877fb6b1264343",
      userId: "6345efd6528436ae8b37f1a1",
      logoUrl: "/images/ico-logo/white.png",
      coverUrl:
        "https://api.impactoverse.com/public/displayImages/cover_1679260267274_715564_c5457987-76ff-4f03-8a9b-3e40298ed972.jpg",
      isFeatured: false,
      name: "Impactoverse",
      about:
        "Impactoverse is an impact ecosystem and Impact Art marketplace. We power brand and cause-driven collaborations to scale business outcomes as well as social and environmental impact.",
      country: "United States",
      city: "Wyoming",
      category: "Science & Technology",
      websiteUrl: "www.impactoverse.com",
      socials: ["https://www.linkedin.com/company/impactoverse/"],
      registrationNum: "882024491",
      countryOfRegistration: "United States",
      activeCampaigns: [
        {
          _id: "64181f64c1877fb6b1264456",
          overview: {
            campaignName: "PetDrops",
            campaignType: "OPEN",
            description:
              "PetDrops is a super-campaign sponsored by Impactoverse benefiting animal welfare organizations.\r\n\r\nAs part of our mission to make web3 more accessible, we created PetDrops as turnkey Impact Art campaign option for people, businesses, and impact initiatives, especially those that are new to the Impact Art space. We chose animal welfare for its universal appeal, as a bridge that can bring together in common purpose across industries, sectors and borders. \r\n\r\nBrands, influencers, or NPOS can easily set up and run approved cause marketing  sub-campaigns under the PetDrops super-campaign umbrella. \r\n\r\nCreators can collaborate with brands or participate directly by contributing, purchasing, or gifting Impact Arts in the PetDrops marketplace. \r\n\r\nPet lovers and other animal welfare advocates can easily and safely purchase and gift Impact Arts in the PetDrops marketplace, no cryptocurrency needed. \r\n\r\nAll transactions benefit animal welfare organizations. Our intention is that, over time, the PetDrops Super Campaign will scale the impact of thousands of sub-campaigns, donating millions of dollars to animal welfare organizations across the globe. \r\n",
            startDate: "2023-03-20T22:13:10.000Z",
            endDate: "2025-12-30T22:00:10.000Z",
            bannerImageUrl: [
              "public/uploads/identityVerifications/banner_1679302334084_228488_ae3fdb3f-a8df-48c1-a332-abf12bdaf025.jpg",
            ],
            isSuperCampaign: true,
            isSubCampaign: false,
            superCampaignId: "",
            superCampaignName: "",
          },
        },
      ],
    },
    {
      _id: "63c3e85f4df378abfe55ccd9",
      userId: "63c3e0964df378abfe55cc94",
      logoUrl:
        "https://api.impactoverse.com/public/displayImages/logo_1674830812017_837870_logo.png",
      coverUrl:
        "https://api.impactoverse.com/public/displayImages/cover_1674830812024_187983_cover.jpg",
      isFeatured: true,
      name: "AUNUA Global",
      about:
        "AUNUA, launched in 2017 is an organization that is FOR YOUTH. FOR IMPACT. With the aim of giving youth a voice, supporting them to develop their individual strengths, and overcome challenges while creating a better world for them to live in. ",
      country: "Ireland",
      city: "Tallaght",
      category: "Education & Training",
      websiteUrl: "www.aunuaglobal.org",
      socials: ["https://www.linkedin.com/company/aunua-academy  "],
      registrationNum: 623198,
      countryOfRegistration: "Ireland",
      activeCampaigns: [
        {
          _id: "6447d36e1fbc6ac0dfdbddb7",
          overview: {
            campaignName: "Masha's Legacy",
            campaignType: "OPEN",
            description:
              "We are grateful to have this campaign as part of the Positive Vibes Movement. Masha Kaylee, 13, a joyful girl, full of life, who loves running, swimming, cycling and other outdoor activities, 4th in her class at school, all set to start secondary (high) school this year. Devastatingly, she was diagnosed with stage 4 bone cancer putting a tragic end to many of her dreams in January of this year, 2023. Only a few months later she is incapacitated and in a wheelchair, with no independence and in a great deal of pain. \n\nWith a change in circumstances, her hobbies now are colouring, and small scale drawings. She uses Art to keep a positive attitude and to keep herself distracted and wants to inspire kids out there in a similar situation, but also wants to do something to help herself as well as others like her.\n\nMuch of the treatment she needs has to be paid for privately, and Masha and other cancer patients and their families often finding themselves making tough choices between getting treatment and medication, or food. This campaign is an opportunity for Masha to use her creative escape and the art of others too to help cover the costs of treatment, food, counselling and transport for her and other children she knows, even for just a short time. \n\nWe hope that you will consider supporting this great cause. In addition to the images you buy being your evidence of the impact you had in the life of children in need, you will also be able to use this as a ticket to the Positive Vibes Festival later this year (live and online). Please see aunuaglobal.com for more. \n\nYou can also support us by contributing some images too, (and you can earn too if your image sells if you choose to get a percentage of the sales), and please share with your network and get them to buy what you contributed. Even if we get a small percentage of the sale of the image you contribute to our campaign, it will help! \n\nIf you're wondering about what we will do with funds, this campaign is to fund meals, counselling and oncologist visits for Masha and 6 other youth for 6 months. \n\nPer youth the cost for 6 months of oncologist visits, meals, vitamin supplements, medication, and counselling would be $1500 ($250 per month)\n\nThis campaign is to support 3 youth to start and we hope to be able to show everyone the work that is being done and gain more support to help more youth and their families.\n\nThe total amount we would be looking to raise is $750 per month for 6 months, so $4500 in total for 6 months.\n\nAgain, please consider buying an image to support and if you can't afford that, please contribute an image toward the campaign and share it and share this campaign. Thank you!",
            startDate: "2023-04-26T11:41:41.000Z",
            endDate: "2024-01-31T11:41:41.000Z",
            bannerImageUrl: [
              "public/uploads/identityVerifications/banner_1682428781936_187581_96176901-b39e-4b26-9ebb-a708af4360a0.png",
            ],
            isSuperCampaign: false,
            isSubCampaign: true,
            superCampaignId: "63c42a6b4df378abfe55cd84",
            superCampaignName: "AUNUA POSITIVE VIBES",
            country: "Uganda",
          },
        },
        {
          _id: "6416fb5cc1877fb6b1264098",
          overview: {
            campaignName: "Esther's Orphanage ",
            campaignType: "OPEN",
            description:
              "This is a campaign that is part of the Positive Vibes movement. We hope that you will support us and spread more positive vibes!!\n\nThe Orphanage is run by Esther who first realised what it felt like to be helpless after losing her dad. She was determined to help other children so that they would never need to experience the same struggles that she had.\n\nShe started the orphanage by supporting 3 children and this has grown with her now looking after the needs of 20, from ages 3 upward.   The orphanage, predominantly through Esther, provides support and security of a home for these vulnerable children who are entirely dependent on the orphanage for their education, clothing, food, shelter and well-being. \n\nDespite Esther's noble intentions for these children and to save them from suffering, life is still a struggle as the orphanage is largely dependent on donations which are in short support. Esther is running this campaign to reduce the dependency on donations, to provide a more sustainable solution to the hunger the children face and a long term solution for their well-being. \n\nFood security is important and this campaign is to fundraise for some land, animals and provisions for a vegetable garden so that the orphanage can be more self-sufficient and less reliant on donations. Please support our campaign by buying an image or event contributing an image and sharing with your network. \n\nThis campaign is a part of the Positive Vibes Super Campaign so all Impact Arts will also give the owners entry to The Positive Vibes Festival in August. More info can be found at aunuaglobal.com. \n\n",
            startDate: "2023-03-20T11:28:58.000Z",
            endDate: "2024-02-29T10:28:58.000Z",
            bannerImageUrl: [
              "public/uploads/identityVerifications/banner_1679308253392_667901_b8890f59-3a62-4675-8926-9a8d4f5d47f1.jpg",
            ],
            isSuperCampaign: false,
            isSubCampaign: true,
            superCampaignId: "63c42a6b4df378abfe55cd84",
            superCampaignName: "AUNUA POSITIVE VIBES",
            country: "Zambia",
          },
        },
      ],
    },
    {
      _id: "64bec1528ca9dd5d4d8e1310",
      userId: "64b424618ca9dd5d4d8df492",
      logoUrl:
        "https://api.impactoverse.com/public/displayImages/logo_1690222930718_724548_acfc6957-c796-4e7c-8292-0cbfbefdf07c.png",
      coverUrl:
        "https://api.impactoverse.com/public/displayImages/cover_1690222930720_262547_4a7d2d49-b547-4a5a-bb29-fd46edb38fb7.png",
      isFeatured: false,
      name: "Onpoint Technologies",
      about:
        "Onpoint Technologies is a tech-driven organization that is setup to explore business opportunities around digital technologies. Our brand as a technology-driven organization focuses on exploring ways to create values of digital/technology humanity in solving day-to-day problems. As an organization in this space, we prioritize innovation, research, and development to stay ahead of the rapidly evolving digital landscape.\r\n\r\nOnpoint Technologies' core mission may revolve around leveraging digital technologies to solve business problems, enhance efficiency, and create new revenue streams. Our expertise include a range of services or products centered around areas such as software development, artificial intelligence, cloud computing, data analytics, internet of things (IoT), cybersecurity, and more.\r\n\r\nOnpoint Technologies has a strong emphasis on fostering a culture of continuous learning and adaptability thereby enabling us to keep up with the ever-changing tech landscape. Collaborating with industry leaders, startups, and other technology-driven businesses is part of our approach to staying at the forefront of tech. ",
      country: "Nigeria",
      city: "Lagos",
      category: "Information & Communication Technology",
      websiteUrl: "www.pointtechblog.com",
      socials: ["https://twitter.com/MapEducates "],
      registrationNum: "3688536",
      countryOfRegistration: "Nigeria",
      activeCampaigns: [],
    },
  ],
};
const renderCheckboxSection = (
  heading,
  options,
  searchQuery,
  otherOptions,
  setOtherOptions,
  respectiveOption,
  sectionStates,
  sectionIndex,
) => {
  const filteredOptions = options.filter((option) =>
    option.toLowerCase().includes(searchQuery.toLowerCase()),
  );
  const handleCheckboxChange = (e, setOptions, otherOptions) => {
    const value = e.target.value;
    setOptions((prevOptions) =>
      e.target.checked
        ? [...prevOptions, value]
        : prevOptions.filter((option) => option !== value),
    );
  };

  return (
    <div className="px-2">
      {filteredOptions.length > 0 && (
        <h2 className="text-lg font-semibold my-2">{heading}</h2>
      )}
      <ul className="flex flex-col flex-wrap">
        {filteredOptions.map((option) => (
          <li key={option}>
            <label className="checkbox-label">
              <input
                type="checkbox"
                className="h-5 w-5 mr-3 rounded border-jacarta-200 text-accent checked:bg-accent focus:ring-accent/20 focus:ring-offset-0 dark:border-jacarta-500 dark:bg-jacarta-600"
                value={option}
                checked={
                  otherOptions.includes(option) ||
                  (respectiveOption && respectiveOption.includes(option))
                }
                onChange={(e) =>
                  handleCheckboxChange(e, setOtherOptions, options)
                }
              />
              {option}
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
};

const CauseElement = ({
  itemFor,
  selectedCampaigns,
  selectedSuperCampaigns,
  selectedCountries,
  selectedImpactCategory,
  searchedObject,
  allData,
}) => {
  const { sortedCollectionData } = useSelector((state) => state.counter);

  const [itemData, setItemData] = useState([]);
  const [localCampaigns, setCampaigns] = useState([]);

  useEffect(() => {
    if (itemFor === "userPage") {
      setItemData(Feature_collections_data.slice(0, 4));
      // console.log(itemData);
    } else {
      setItemData(sortedCollectionData);
    }
  }, [sortedCollectionData, itemFor]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        //const response = await fetch("https://api.impactoverse.com/api/app/all-campaigns");
        const data = allData;

        if (data) {
          // Filter the data based on selected options
          const filteredCampaigns = data.brandsList.filter((campaign) => {
            return (
              !selectedCampaigns ||
              selectedCampaigns.includes(campaign.name) ||
              !selectedCountries ||
              selectedCountries.includes(campaign.country) ||
              !selectedImpactCategory ||
              selectedImpactCategory.includes(campaign.category) ||
              searchedObject.label === campaign.name ||
              (searchedObject.heading === "Countries" &&
                searchedObject.label === campaign.country) ||
              (searchedObject.heading === "Impact Categories" &&
                searchedObject.label === campaign.category)
            );
          });
          console.log(
            "selected searched ",
            searchedObject.label,
            searchedObject.heading,
          );
          console.log(filteredCampaigns);

          // setCampaigns(filteredCampaigns);
          let tempArray = [];
          {
            const newObj = {
              count: data?.count || {},
              campaigns:
                filteredCampaigns.length > 0
                  ? filteredCampaigns
                  : data.brandsList,
            };
            tempArray.push(newObj);
          }
          // console.log("This is new Obj", newObj.count);
          setCampaigns(tempArray);
        } else {
          console.error("API request failed:", data.error);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [
    selectedCampaigns,
    selectedSuperCampaigns,
    selectedCountries,
    selectedImpactCategory,
    searchedObject,
    allData,
  ]);

  return (
    <>
      {localCampaigns.map((item) => {
        const { campaigns } = item;
        // console.log("Campaign Id", campaigns);

        return campaigns.map((campaignItem, campaignIndex) => {
          const {} = campaignItem;
          // console.log("Campaign Item", campaignItem);
          const imageName = campaignItem.name;
          const campaignId = campaignItem._id;
          const imageUrl = campaignItem.logoUrl;
          console.log("This is the description", campaignItem.about);

          return (
            <article key={campaignId}>
              <div
                className="relative mb-12 rounded-2.5xl border border-jacarta-100 bg-white p-12 transition-shadow hover:shadow-xl dark:border-jacarta-700 dark:bg-jacarta-700 "
                key={campaignId}
              >
                <div className="text-center newseLatter-item" key={campaignId}>
                  <div
                    className={`mb-6 inline-flex rounded-full p-3`}
                    style={{ backgroundColor: "#beaaf7" }}
                  >
                    <div
                      className={` items-center justify-center rounded-full`}
                    >
                      <Image
                        src={`${imageUrl}`}
                        alt={`${campaignItem.name} Logo`}
                        width={64}
                        height={64}
                        className="rounded-full h-16 w-16 object-contain"
                      />
                    </div>
                  </div>
                </div>
                <span className="mb-2 inline-block text-2xs font-medium text-accent line-clamp-1">
                  {campaignItem.category}
                </span>
                <h3 className="mb-4 font-display text-lg text-jacarta-700 dark:text-white line-clamp-1">
                  {imageName}
                </h3>
                <p className="dark:text-jacarta-300 line-clamp-2">
                  {" "}
                  {campaignItem.about}
                </p>

                <Link href={`brands/${campaignItem._id}`}>
                  <button className="hover:bg-accent-dark font-display bg-accent rounded-full px-6 py-2 mt-4 text-sm text-white">
                    Campaigns
                  </button>
                </Link>
                <Link href={`brands/${campaignItem._id}`}>
                  <div className="absolute -bottom-6 left-1/2 inline-flex h-12 w-12 -translate-x-1/2 items-center justify-center rounded-full bg-light-base dark:bg-jacarta-600">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="20"
                      height="20"
                      className="fill-accent dark:fill-accent-lighter"
                    >
                      <path fill="none" d="M0 0h24v24H0z"></path>
                      <path d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z"></path>
                    </svg>
                  </div>
                </Link>
              </div>
            </article>
          );
        });
      })}
    </>
  );
};

import React, { useState, useRef, useEffect } from "react";

import { HeadLine } from "../../components/component";

import Explore_collection_item from "../../components/collectrions/explore_collection_item";
import Meta from "../../components/Meta";
import Image from "next/image";
import {
  CampaignSvg,
  CountrySvg,
  ImpactCategorySvg,
  SuperCampaignSvg,
} from "../../components/svg/svgFilesGlobal";
import { useSelector } from "react-redux";
import Link from "next/link";
import { truncateText } from "../../utils/functions";
import Browse_category_carousel from "../../components/carousel/Browse_category_carousel";
import Brand_campaign_carasoul from "../../components/brand/brand_campaigns";
export const baseURL = `${process.env.BASE_URL}/`;

const Explore_brands = () => {
  const inputRef = useRef(null);
  const campaignInputRef = useRef(null);
  const superCampaignInputRef = useRef(null);
  const impactCategoryInputRef = useRef(null);
  const countryInputRef = useRef(null);
  useEffect(() => {
    const handleDocumentClick = (e) => {
      if (
        inputRef.current &&
        !inputRef.current.contains(e.target) &&
        campaignInputRef.current &&
        !campaignInputRef.current.contains(e.target) &&
        superCampaignInputRef.current &&
        !superCampaignInputRef.current.contains(e.target) &&
        impactCategoryInputRef.current &&
        !impactCategoryInputRef.current.contains(e.target) &&
        countryInputRef.current &&
        !countryInputRef.current.contains(e.target)
      ) {
        setDropdownShow(false);
        setSuperCampaignDropdownShow(false);
        setcampaignDropdownShow(false);
        setImpactCategoryDropDownShow(false);
        setCountryDropDownShow(false);
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const handleInputFocus = () => {
    setDropdownShow(true);
    setSuperCampaignDropdownShow(false);
    setcampaignDropdownShow(false);
    setImpactCategoryDropDownShow(false);
    setCountryDropDownShow(false);
  };
  const [campaignOptions, setCampaignOptions] = useState([]);
  const [superCampaignOptions, setSuperCampaignOptions] = useState([]);
  const [impactCategoryOptions, setImpactCategoryOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);

  const [campaignDropDownShow, setcampaignDropdownShow] = useState(false);
  const [superCampaignDropDownShow, setSuperCampaignDropdownShow] =
    useState(false);
  const [impactCategoryDropDownShow, setImpactCategoryDropDownShow] =
    useState(false);

  const [countryDropDownShow, setCountryDropDownShow] = useState(false);

  const handleSuperCampaignDropdown = () => {
    setcampaignDropdownShow(false);
    setCountryDropDownShow(false);
    setImpactCategoryDropDownShow(false);
    setDropdownShow(false);

    setSuperCampaignDropdownShow(!superCampaignDropDownShow);
  };
  const [selectedCampaignOptions, setSelectedCampaignOptions] = useState([]);
  const [selectedSuperCampaignOptions, setSelectedSuperCampaignOptions] =
    useState([]);
  const [selectedImpactCategoryOptions, setSelectedImpactCategoryOptions] =
    useState([]);
  const [selectedCountryOptions, setSelectedCountryOptions] = useState([]);
  const [searchedValue, setSearchedValue] = useState({});
  const [allData, setAllData] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        // https://api.impactoverse.com/api/app/active-causes?isFeatured=false%22
        const response = await fetch(
          `${process.env.NEXT_PUBLIC_BASE_URL}/api/app/active-brands?isFeatured=false`,
        );
        const data = topBrands;

        if (data.success) {
          setAllData(data);
          const uniqueCampaigns = [
            ...new Set(data.brandsList.map((campaign) => campaign.name)),
          ].filter((campaign) => campaign && campaign.trim() !== ""); // Filter null or empty values
          setCampaignOptions(uniqueCampaigns);

          const uniqueImpactCategories = [
            ...new Set(data.brandsList.map((campaign) => campaign.category)),
          ].filter((category) => category && category.trim() !== ""); // Filter null or empty values
          setImpactCategoryOptions(uniqueImpactCategories);

          const uniqueCountries = [
            ...new Set(data.brandsList.map((campaign) => campaign.country)),
          ].filter((country) => country && country.trim() !== ""); // Filter null or empty values
          setCountryOptions(uniqueCountries);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const handlecampaignDropdown = () => {
    setCountryDropDownShow(false);
    setImpactCategoryDropDownShow(false);
    setSuperCampaignDropdownShow(false);
    setDropdownShow(false);

    setcampaignDropdownShow(!campaignDropDownShow);
  };
  const handleImpactCategoryDropdown = () => {
    setcampaignDropdownShow(false);
    setDropdownShow(false);

    setCountryDropDownShow(false);
    setSuperCampaignDropdownShow(false);
    setImpactCategoryDropDownShow(!impactCategoryDropDownShow);
  };
  const handleCountryDropdown = () => {
    setcampaignDropdownShow(false);
    setImpactCategoryDropDownShow(false);
    setDropdownShow(false);

    setSuperCampaignDropdownShow(false);
    setCountryDropDownShow(!countryDropDownShow);
  };
  const handleCheckboxChange = (e, setOptions) => {
    const value = e.target.value;
    setOptions((prevOptions) =>
      e.target.checked
        ? [...prevOptions, value]
        : prevOptions.filter((option) => option !== value),
    );
  };
  const handleRemoveOption = (option, setOptions) => {
    setOptions((prevOptions) =>
      prevOptions.filter((prevOption) => prevOption !== option),
    );
  };

  const [dropdownShow, setDropdownShow] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  return (
    <>
      <Meta title="Explore Brands & Agencies || Impactoverse " />
      <section className="relative mt-24 lg:pb-48 pb-24">
        <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
          <Image
            width={1519}
            height={773}
            priority
            src="/images/gradient_light.jpg"
            alt="gradient"
            className="h-full"
          />
        </picture>

        <div className="container">
          <HeadLine
            text="Explore Brands & Agencies"
            classes="font-display text-jacarta-700 py-16 text-center text-4xl font-medium dark:text-white"
          />

          {/* <!-- Filter --> */}

          {/* <!-- Grid --> */}
          <div className="mb-8 flex flex-wrap items-start justify-between">
            <div className="flex flex-wrap items-center justify-between">
              <div className="flex flex-wrap items-center">
                <div className="my-1 mr-2.5 relative" ref={campaignInputRef}>
                  <button
                    className="group dropdown-toggle dark:border-jacarta-600 dark:bg-jacarta-700 group dark:hover:bg-accent hover:bg-accent border-jacarta-100 font-display text-jacarta-700 flex h-9 items-center rounded-lg border bg-white px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white dark:text-white"
                    onClick={handlecampaignDropdown}
                  >
                    <CampaignSvg />
                    <span>Brands & Agencies</span>
                  </button>
                  {/* Dropdown Menu */}
                  {campaignDropDownShow && (
                    <div className="z-10 min-w-fit px-2 py-2 w-full dark:bg-jacarta-800 whitespace-nowrap rounded-xl bg-white text-left shadow-xl show absolute top-full">
                      <ul className="flex flex-col flex-wrap">
                        {campaignOptions.map((option) => (
                          <li key={option}>
                            <label className="checkbox-label">
                              <input
                                type="checkbox"
                                value={option}
                                className="h-5 cursor-pointer w-5 mr-3 rounded border-jacarta-200 text-accent checked:bg-accent focus:ring-accent/20 focus:ring-offset-0 dark:border-jacarta-500 dark:bg-jacarta-600"
                                // checked={selectedCampaignOptions.includes(option)}
                                checked={
                                  selectedSuperCampaignOptions.includes(
                                    option,
                                  ) || selectedCampaignOptions.includes(option)
                                }
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    setSelectedCampaignOptions,
                                  )
                                }
                              />
                              {option}
                            </label>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>

                <div
                  className="my-1 mr-2.5 relative"
                  ref={impactCategoryInputRef}
                >
                  <button
                    className="group  dropdown-toggle dark:border-jacarta-600 dark:bg-jacarta-700 group dark:hover:bg-accent hover:bg-accent border-jacarta-100 font-display text-jacarta-700 flex h-9 items-center rounded-lg border bg-white px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white dark:text-white"
                    onClick={handleImpactCategoryDropdown}
                  >
                    <ImpactCategorySvg />
                    <span>Impact Category</span>
                  </button>
                  {/* Dropdown Menu */}

                  {impactCategoryDropDownShow && (
                    <div className="dropdown-menu ml-2.5 dark:bg-jacarta-800 z-10 min-w-fit px-2 py-2 w-full whitespace-nowrap rounded-xl bg-white text-left shadow-xl show absolute top-full">
                      <ul className="flex flex-col flex-wrap">
                        {impactCategoryOptions.map((option) => (
                          <li key={option}>
                            <label className="checkbox-label">
                              <input
                                type="checkbox"
                                className="h-5 w-5 mr-3 rounded border-jacarta-200 text-accent checked:bg-accent focus:ring-accent/20 focus:ring-offset-0 dark:border-jacarta-500 dark:bg-jacarta-600 "
                                value={option}
                                checked={selectedImpactCategoryOptions.includes(
                                  option,
                                )}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    setSelectedImpactCategoryOptions,
                                  )
                                }
                              />
                              {option}
                            </label>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
                <div className="my-1 mr-2.5 relative" ref={countryInputRef}>
                  <button
                    className="group dropdown-toggle dark:border-jacarta-600 dark:bg-jacarta-700 group dark:hover:bg-accent hover:bg-accent border-jacarta-100 font-display text-jacarta-700 flex h-9 items-center rounded-lg border bg-white px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white dark:text-white"
                    onClick={handleCountryDropdown}
                  >
                    <CountrySvg />
                    <span>Country</span>
                  </button>
                  {/* Dropdown Menu */}
                  {countryDropDownShow && (
                    <div className="z-10 min-w-fit px-2 py-2 w-full dark:bg-jacarta-800 whitespace-nowrap rounded-xl bg-white text-left shadow-xl show absolute top-full">
                      <ul className="flex flex-col flex-wrap">
                        {countryOptions.map((option) => (
                          <li key={option}>
                            <label className="checkbox-label">
                              <input
                                type="checkbox"
                                className="h-5 w-5 mr-3 rounded border-jacarta-200 text-accent checked:bg-accent focus:ring-accent/20 focus:ring-offset-0 dark:border-jacarta-500 dark:bg-jacarta-600"
                                value={option}
                                checked={selectedCountryOptions.includes(
                                  option,
                                )}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    setSelectedCountryOptions,
                                  )
                                }
                              />
                            </label>
                            {option}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="my-1 mr-2.5 relative " ref={inputRef}>
              <div
                className={`flex h-10 box-border flex-row relative rounded-lg ${
                  dropdownShow ? "border border-accent" : ""
                }`}
              >
                <input
                  onFocus={handleInputFocus}
                  placeholder="Search"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className={`
      font-bold text-jacarta-700 rounded-lg placeholder-jacarta-500 w-full py-2 px-1 pl-10
      dark:bg-white/[.15] dark:text-white dark:placeholder-white
      focus:outline-none focus:border-accent focus:border-1 box-border
    `}
                />
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width={20}
                  height={20}
                  className="fill-jacarta-500 h-5 w-5 dark:fill-white absolute left-3 top-1/2 transform -translate-y-1/2"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path d="M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15z" />
                </svg>
              </div>

              {dropdownShow && (
                <div className="dropdown-menu h-[300px] overflow-y-auto dark:bg-jacarta-800 px-2 py-2 min-w-fit w-full ml-2.5 whitespace-nowrap rounded-xl bg-white text-left shadow-xl show absolute top-full z-10">
                  {renderCheckboxSection(
                    "Brands & Agencies",
                    campaignOptions,
                    searchQuery,
                    selectedCampaignOptions,
                    setSelectedCampaignOptions,
                    selectedSuperCampaignOptions,
                  )}
                  {renderCheckboxSection(
                    "Super Campaign",
                    superCampaignOptions,
                    searchQuery,
                    selectedSuperCampaignOptions,
                    setSelectedSuperCampaignOptions,
                    selectedCampaignOptions,
                  )}
                  {renderCheckboxSection(
                    "Impact Category",
                    impactCategoryOptions,
                    searchQuery,
                    selectedImpactCategoryOptions,
                    setSelectedImpactCategoryOptions,
                  )}
                  {renderCheckboxSection(
                    "Countries",
                    countryOptions,
                    searchQuery,
                    selectedCountryOptions,
                    setSelectedCountryOptions,
                  )}
                </div>
              )}
            </div>
            <div className="relative w-full mt-7 flex flex-row flex-wrap gap-2 ">
              {selectedCampaignOptions.map((option) => (
                <div
                  key={option}
                  className="selected-option  dark:border-jacarta-600 py-1 dark:bg-jacarta-700    border-jacarta-100 font-display text-jacarta-700 flex items-center gap-3 justify-between rounded-lg border bg-white px-2 text-sm font-semibold   dark:text-white"
                >
                  <p>Brand :</p> {option}{" "}
                  <button
                    onClick={() =>
                      handleRemoveOption(option, setSelectedCampaignOptions)
                    }
                  >
                    X
                  </button>
                </div>
              ))}
              {selectedImpactCategoryOptions.map((option) => (
                <div
                  key={option}
                  className=" dark:border-jacarta-600 py-1 dark:bg-jacarta-700    border-jacarta-100 font-display text-jacarta-700 flex items-center gap-3 justify-between rounded-lg border bg-white px-2 text-sm font-semibold   dark:text-white"
                >
                  <p>Impact Category :</p> {option}{" "}
                  <button
                    onClick={() =>
                      handleRemoveOption(
                        option,
                        setSelectedImpactCategoryOptions,
                      )
                    }
                  >
                    X
                  </button>
                </div>
              ))}
              {selectedCountryOptions.map((option) => (
                <div
                  key={option}
                  className="selected-option  dark:border-jacarta-600 py-1 dark:bg-jacarta-700 border-jacarta-100 font-display text-jacarta-700 flex items-center gap-3 justify-between rounded-lg border bg-white px-2 text-sm font-semibold dark:text-white"
                >
                  <p>Country :</p> {option}{" "}
                  <button
                    onClick={() =>
                      handleRemoveOption(option, setSelectedCountryOptions)
                    }
                  >
                    X
                  </button>
                </div>
              ))}
            </div>
          </div>
          <div className="grid grid-cols-1 gap-[1.875rem] md:grid-cols-3 lg:grid-cols-3">
            {allData && (
              <CauseElement
                itemFor="explore-collection"
                selectedCampaigns={selectedCampaignOptions}
                selectedSuperCampaigns={selectedSuperCampaignOptions}
                selectedCountries={selectedCountryOptions}
                selectedImpactCategory={selectedImpactCategoryOptions}
                searchedObject={searchedValue}
                allData={allData}
              />
            )}
          </div>
        </div>
      </section>
    </>
  );
};
export default Explore_brands;
